/* La tira de reseñas: sin fin y con flechas.

   Sin fin de verdad: se llega al final y sigue habiendo reseñas, hacia un
   lado y hacia el otro. No se consigue imprimiendo la tira tres veces -como
   la de campañas, que son diez tarjetas- porque aquí son más de treinta: el
   HTML de la franja se triplicaría en la portada y en cada ficha, y esto se
   ve sobre todo con datos móviles.

   Así que las tarjetas se reciclan. Cuando la tira se para, la que ya se ha
   quedado atrás se pasa al final y se le resta su ancho al scroll: la tira
   no se mueve ni un píxel a la vista, pero por delante siempre queda más.
   Al revés igual. Al cargar se lleva el último tramo al principio y el
   scroll se coloca justo detrás, así la primera reseña sigue siendo la
   primera que se ve y además ya se puede ir hacia atrás.

   Se recicla sólo cuando la tira está quieta: mover tarjetas a mitad de un
   desplazamiento suave lo cancela, y se vería el frenazo. El colchón es de
   una pantalla a cada lado, que da de sobra para que nunca se alcance el
   borde entre parada y parada.

   Con pocas reseñas -o una pantalla muy ancha- no hay bucle: si la tira
   entera cabe casi en pantalla no hay nada que dar la vuelta, y entonces las
   flechas se apagan en los extremos como cualquier carrusel normal. */
if (!customElements.get('lv-tira-resenas')) {
  customElements.define(
    'lv-tira-resenas',
    class extends HTMLElement {
      connectedCallback() {
        if (this.tira) return;
        this.tira = this.querySelector('[data-tira]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.tira || !this.prev || !this.next) return;

        this.prev.addEventListener('click', () => this.mover(-1));
        this.next.addEventListener('click', () => this.mover(1));

        this.medir();
        if (this.bucle) this.colchon();

        // scrollend avisa cuando la tira se para de verdad, con su inercia y
        // su imán. Donde no existe, un scroll que lleva 140 ms quieto se da
        // por parado.
        if ('onscrollend' in window) {
          this.tira.addEventListener('scrollend', () => this.alPararse());
        } else {
          this.tira.addEventListener(
            'scroll',
            () => {
              clearTimeout(this.espera);
              this.espera = setTimeout(() => this.alPararse(), 140);
            },
            { passive: true }
          );
        }

        window.addEventListener('resize', () => {
          this.medir();
          this.alPararse();
        });

        this.repasar();
      }

      // El hueco entre tarjetas cambia con la pantalla, y con él el ancho de
      // un paso. Y el bucle sólo se monta si sobra tira: el doble de lo que
      // se ve es lo mínimo para que el reciclaje nunca deje un borde a la
      // vista.
      medir() {
        const cs = getComputedStyle(this.tira);
        this.hueco = parseFloat(cs.columnGap || cs.gap) || 0;
        this.bucle = this.tira.scrollWidth > this.tira.clientWidth * 2;
      }

      anchoDe(pieza) {
        return pieza ? pieza.offsetWidth + this.hueco : 0;
      }

      colchon() {
        const t = this.tira;
        let puesto = 0;
        let guardia = 0;
        while (puesto < t.clientWidth && t.lastElementChild && guardia++ < 80) {
          const ultima = t.lastElementChild;
          puesto += this.anchoDe(ultima);
          t.insertBefore(ultima, t.firstElementChild);
        }
        t.scrollLeft = puesto;
      }

      alPararse() {
        // Nunca a mitad de un viaje de las flechas: tocar el scroll durante
        // un desplazamiento suave lo cancela en seco, y lo que se veía era
        // que la flecha «no avanzaba».
        if (this.enMarcha) return;
        if (this.bucle) this.reciclar();
        this.repasar();
      }

      reciclar() {
        const t = this.tira;
        const colchon = t.clientWidth;
        let guardia = 0;

        // Se suelta el imán del scroll mientras se recoloca. El imán intenta
        // conservar la tarjeta a la que estaba pegado, así que al llevarla al
        // otro extremo deshacía la compensación y la tira se quedaba clavada:
        // dos pulsaciones de flecha para avanzar una tarjeta. Se devuelve en
        // el cuadro siguiente, cuando el scroll ya está en su sitio nuevo
        // -que es justo un punto de imán-, así que no se nota.
        this.classList.add('is-recolocando');

        // Lo que ya quedó muy atrás se va al final.
        while (
          t.scrollLeft > colchon + this.anchoDe(t.firstElementChild) &&
          guardia++ < 80
        ) {
          const primera = t.firstElementChild;
          const ancho = this.anchoDe(primera);
          t.appendChild(primera);
          t.scrollLeft -= ancho;
        }

        // Y si el colchón de la izquierda se ha quedado corto, se rellena
        // con las de atrás.
        while (t.scrollLeft < colchon && guardia++ < 80) {
          const ultima = t.lastElementChild;
          const ancho = this.anchoDe(ultima);
          t.insertBefore(ultima, t.firstElementChild);
          t.scrollLeft += ancho;
        }

        cancelAnimationFrame(this.iman);
        this.iman = requestAnimationFrame(() => this.classList.remove('is-recolocando'));
      }

      // Se recoloca ANTES de salir, con la tira quieta, y no después: así el
      // reciclaje nunca pilla un desplazamiento en marcha. Si se pulsa otra
      // vez sin haber llegado, no se recoloca: se alarga el destino, y las
      // pulsaciones seguidas se encadenan sin frenazos.
      mover(sentido) {
        if (!this.enMarcha && this.bucle) this.reciclar();
        const paso = this.anchoDe(this.tira.firstElementChild);
        const desde = this.enMarcha ? this.destino : this.tira.scrollLeft;
        this.destino = desde + paso * sentido;
        this.enMarcha = true;
        const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tira.scrollTo({ left: this.destino, behavior: sinMovimiento ? 'auto' : 'smooth' });
        this.vigilar(0);
      }

      // Da el viaje por terminado cuando la tira llega -o cuando lleva un
      // segundo y medio sin llegar, que es que alguien la ha movido a mano o
      // el destino se quedó fuera del recorrido.
      vigilar(intentos) {
        clearTimeout(this.reloj);
        if (Math.abs(this.tira.scrollLeft - this.destino) > 2 && intentos < 15) {
          this.reloj = setTimeout(() => this.vigilar(intentos + 1), 100);
          return;
        }
        this.enMarcha = false;
        this.alPararse();
      }

      // Con bucle no hay extremos, así que las dos flechas se quedan siempre.
      repasar() {
        if (this.bucle) {
          this.prev.hidden = false;
          this.next.hidden = false;
          return;
        }
        const margen = 2;
        const fin = this.tira.scrollWidth - this.tira.clientWidth;
        this.prev.hidden = this.tira.scrollLeft <= margen;
        this.next.hidden = this.tira.scrollLeft >= fin - margen;
      }
    }
  );
}
